import { Button } from 'component/Button'
import { useDropdown } from 'component/Dropdown/DropdownContext'
import { Divider, Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { MaxPriceInput } from 'page/catalog/price/MaxPriceInput'
import { MinPriceInput } from 'page/catalog/price/MinPriceInput'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { emdash } from 'util/typo'

export const PricePopover = observer(() => {
  const demo = useDemo()
  const { setOpen } = useDropdown()
  const width = 160

  const onReset = useLatestCallback(() => {
    demo.form.min_price = null
    demo.form.max_price = null
    demo.search()
    setOpen(false)
  })

  const onApply = useLatestCallback(() => {
    demo.search()
    setOpen(false)
  })

  return <Vertical gap={16} pad={[16, 0]} center>
    <Space>
      <Space width={width}>
        <MinPriceInput />
      </Space>
      <Space width={24} center>
        <Typo size={11} medium>
          {emdash}
        </Typo>
      </Space>
      <Space width={width}>
        <MaxPriceInput />
      </Space>
    </Space>
    <Divider secondary />
    <Space gap={16} wide right>
      <Button action={onReset}>
        {i18n('Reset')}
      </Button>
      <Button primary action={onApply}>
        {i18n('demo.Apply')}
      </Button>
    </Space>
  </Vertical>
})
